import React, { Component } from "react";
import Intro from "../../components/OurAcademicSections/Intro/Intro";
import Message from "../../components/OurAcademicSections/Message/Message";
import Ratio from "../../components/OurAcademicSections/Ratio/Ratio";
import Banner from '../../components/OurAcademicSections/Banner/Banner'
import TopFour from "../../components/OurAcademicSections/TopFour/TopFour";
import ResearchMessage from '../../components/OurAcademicSections/ResearchMessage/ResearchMessage'
import StatsSection from '../../components/OurAcademicSections/StatsSection/StatsSection'
import NextPage from "../../components/UI/NextPage/NextPage";
import { Helmet } from "react-helmet";

class AcademicEndeavors extends Component {
  componentDidMount() {
    try {
      window.scroll({
        top: 0,
        left: 0,
      });
    } catch (error) {
      window.scrollTo(0, 0);
    }
  }

  render() { 
    return (
      <React.Fragment>
        <Helmet>
        <meta charSet="utf-8" />
          <title>Dickinson Viewbook | Our Academic Endeavors</title>
        </Helmet>
        <Intro />
        <Message />
        <Ratio />
        <Banner />
        <TopFour />
        <ResearchMessage />
        <StatsSection />
        {/* <LargePhoto src={image} alt="Student and Professor working together" /> */}
        <NextPage link="/alumni-success" title="Our Alumni Success" />
      </React.Fragment>
    );
  }
}

export default AcademicEndeavors;
